import Common from '../../../../Common';

interface Body {
	contact_email: string
	contact_number: string
	items: Array<{
		date: string
		name: string
		number: string
		operator?: string
		self_service_pricelist_program_id: id
		sim_id: id
		ssn: string
	}>
}

const Port = class extends Common {
	create = (companyId: id, data: Body) =>
		this.post(`/company/${companyId}/selfservice/subscription/port`, data);
}

export default Port;
